<template>
     <div class="publicViewClass" style="padding-top:0">
        <div class="edit-step">
            <topicSteps :active = "1" :propList="propList"></topicSteps>
        </div> 
         <div id="editPaper" class="app-inner">
          <div class="public-btn-small flex align-cen posta">
            <div class="public-btn-small-plan"  style="margin-left:0" @click="$util.reback('/teacheManage/enSimulationPaper')">
            返回
            </div>
           <el-button type="primary"  :loading="loading" class="public-btn-small-primary public-btn-small-load" style="margin-left:16px"
           @click="openSteps('ruleForm')"
            >
             下一步
           </el-button>
            </div>
              <div class="edit-from">
                 <div class="public-tit flex align-cen">
            <div class="public-tit-list">
                <i class="icon-al-database-fill"></i>  基本信息
            </div>
        </div>
         <el-form ref="ruleForm" :model="form" label-width="150px" :rules="rules" class="flex align-cen">
            <el-form-item label="试卷标题：" prop="paperName">
                    <el-input v-model="form.paperName" placeholder="请输入您的试卷标题【1-50】" clearable></el-input>
             </el-form-item>
               <el-form-item label="关联仿真应用：" prop="appId">
                    <el-select v-model="form.appId" placeholder="选择关联应用：">
                        <el-option
                        v-for="item in options"
                        :key="item.id"
                        :label="item.appName === '未分类' ? '未分类' : item.appName"
                        :value="item.id"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                      <el-form-item label="试卷封面：" prop="logo">
                    <el-upload
                    class="avatar-uploader"
                    :action="$config.baseUrl + '/admin/sys-file/upload'"
                    :headers="headers"
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess"
                    :before-upload="$util.beforeUpload"
                    :disabled="uploadBoolean"
                    >
                    <div slot="tip" class="el-upload__tip" >建议尺寸：<span style="color:#f56c6c">220*140</span></div>
                    <img :src="form.logo" class="avatar" v-if="form.logo">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                       <!--页面新增删除和预览-->
                    <span v-if="form.logo" class="el-upload-list__item-actions">
                        <span class="upload-icon">
                            <span class="el-uploads-span" style="margin-right: 10px;" @click.stop="oploadImgPre">
                                <i class="el-icon-zoom-in"></i>
                            </span>
                            <span class="el-upload-span" @click.stop="oploadImgDel">
                                <i class="el-icon-delete"></i>
                            </span>
                        </span>
                    </span>
                    <el-dialog :visible.sync="oploadDialogVisible" size="tiny" :append-to-body="true" :show-close="false">
                        <img width="100%" :src="form.logo" alt="">
                    </el-dialog>
                    </el-upload>
                 </el-form-item>
         </el-form>
              </div>
         </div>
     </div>
</template>
<script>
import topicSteps from "@/components/topicSteps/index.vue"; //步骤条组件
import {getTeacherAppList,editEmuPaper,EmuPaperDetail} from "@/api/enterprise/index"   //关联仿真应用、新增试卷、查询仿真试卷详情
import LocaStorage from "../../../utils/localstorage.js" //本地存储公共方法
import debounce from '../../../utils/debounce.js' //防抖
export default {
name:'addRaso',
components: {
        topicSteps,
    },
data() {
    return {
        businessInfo:{},
        nextId:'',
        oploadDialogVisible:false,
        uploadBoolean:false,
        form:{
        paperName:'',
        logo:'',
        businessId:'',
        appId:''
        },
        rules:{
             paperName: [{ required: true, message: '请输入您的试卷标题', trigger: 'blur' },
             { min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
             ],
              appId: [{ required: true, message: '请选择关联仿真应用', trigger: 'change' }],
              logo:[{ required: true, message: '请上传试卷封面图', trigger: 'blur' }],
        },
        headers:{},
        loading:false,
        options:[],
        propList:[
            {
                steps:1,
                text:'基本信息',
            },
            {
                steps:2,
                text:'配置步骤',
            },{
                steps:3,
                text:'试卷设置',
            },{
                steps:4,
                text:'完成', 
            }

        ]
    }
},    
created() {
    this.businessInfo = this.$locaStorage.setAge().get('businessInfo')
    this.getApplist()
    this.getPaperDetail()
      let token = LocaStorage.setAge().get('token1')
        if(token){
            this.headers = {
                'Authorization': token
            }
        }
},
methods: {
    getPaperDetail(){
            EmuPaperDetail({id:this.$route.query.id},'get')
            .then(res =>{
                console.log(res)
               this.form = {
                paperName:res.data.paperName,
                appId:res.data.appId,
                logo:res.data.logo,
                businessId:'',
                }
            })
            .catch(err =>{})
        },
    // 下一步
    openSteps(formName){
         let params = { ...this.form};
         let method = "post"
         if(!this.$route.query.id) params = {...this.form,businessId:this.businessInfo.id},method = "post";
         if(this.$route.query.id) params = {...this.form,id:this.$route.query.id,businessId:this.businessInfo.id}, method = "put";
         this.$refs[formName].validate((valid) => {  
                     if(valid){
                 //防抖提交
                    debounce(() => {
                        this.commentBness(params,method)
                    }, 500)
                        }else{
                          this.$util.Notifi('请填写或上传必填项','error','fa-exclamation-circle');
                        }
                    }) 
    },
             commentBness(params,method){
               this.loading = true
                editEmuPaper(params,method)
                        .then(res => {
                           if(res.code == 0){
                            this.loading = false
                            if(!this.$route.query.id) this.$message.success('新增成功'),this.nextId = res.data.id; 
                                setTimeout(() => {
                           this.$router.push({
                            name:'twoEnRaso',
                            query:{
                                twoId:this.$route.query.id || this.nextId
                            }
                           })
                             }, 100);
                           }else{
                             this.loading = false
                            this.$message.error(res.msg)
                           }
                        })
                        .catch(err => {
                           this.loading = false
                        })
        },
       // 图片放大
         oploadImgPre(){
            this.oploadDialogVisible = true
            },
        oploadImgDel(){
            this.form.logo = ''
                let _this= this
                setTimeout(function(){
                    _this.uploadBoolean = false
                },1000)
        },
         handleAvatarSuccess(res, file) {
        this.form.logo = res.data.url
        
        if(this.form.pic){
        this.uploadBoolean = true
         }
      },
     // 关联仿真应用
          getApplist(){
            getTeacherAppList({
                  id:this.businessInfo.id,
                  accountId:'',
                  officialType:''
              })
            .then(res => {
              this.options = res.data
            })
            .catch(err => {
            })
        },
}
}

</script>
<style lang="scss" scoped>
   .edit-from{
         margin-bottom: 44px;
         .edit-from-tit{
             background: rgb(215, 215, 215);
             padding: 10px 20px;
             font-size: 18px;
         }
           .el-form{
            flex-wrap: wrap;
            margin-top: 20px;
         .el-form-item{
            width: 50%;
        .el-input,.el-cascader{
            width: 80%;
        }
        .el-select,.el-input-group{
            width: 80%;
        }
        .el-textarea{
            width: 80%;
        }
        
        }
         }
         .App-tab{
            margin: 20px 0;
            
        }
         }
           ::v-deep{
 .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 80px;
    height: 80px;
    line-height: 80px;
    text-align: center;
  }
  
  .avatar {
    width: 371px;
    height: 130px;
    display: block;
  }
  .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 200px;
        height: 200px;
        line-height: 200px;
        text-align: center;
    }
   .upload-icon {
        position: absolute;
        top: 50%;
        margin-left: -28px;
        margin-top: -18px;
    }
    .uploadPicture{
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 50px;
        background: rgba(0,0,0,.6);
        color: #fff;
        line-height: 50px;
        text-align: center;
    }
    .el-dialog{
        width: 50%;
    }
  }
</style>